import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetBranch } from '~/hooks';

type Args = {
  branchId: number;
};

export const useEditBranchFormHeader = ({ branchId }: Args) => {
  const { data } = useGetBranch({
    threeLetterCode: getThreeLetterCode() || '',
    branchId,
  });
  return { branchName: data.branch.name };
};
